/** Query-string key that selects (and deep-links) the analysis shown on the ICP page. */
export const ICP_ANALYSIS_PARAM = 'analysis';

/** Canonical URL of an aquarium's ICP analysis page, optionally with one analysis selected. */
export function icpAnalysesPath(aquariumId: string, analysisId?: string | null): string {
  const base = `/aquariums/${aquariumId}/icp-analyses`;
  return analysisId ? `${base}?${ICP_ANALYSIS_PARAM}=${encodeURIComponent(analysisId)}` : base;
}

/**
 * Router state the upload page hands to the ICP page so it can show the
 * one-time import notice for the new analysis (values stored + parameters
 * below the detection limit). Not persisted: a reload drops it.
 */
export interface IcpImportState {
  icpImport: {
    analysisId: string;
    parameterCount: number;
    belowDetection: Array<{ key: string; providerParameterName?: string; limit?: number; unit?: string }>;
  };
}

/** Reads IcpImportState from `location.state`, tolerating anything else. */
export function readIcpImportState(state: unknown): IcpImportState['icpImport'] | null {
  if (typeof state !== 'object' || state === null) return null;
  const value = (state as Partial<IcpImportState>).icpImport;
  if (typeof value !== 'object' || value === null) return null;
  if (typeof value.analysisId !== 'string' || typeof value.parameterCount !== 'number') return null;
  return { ...value, belowDetection: Array.isArray(value.belowDetection) ? value.belowDetection : [] };
}
